var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", {
    staticClass: "lt",
    attrs: { "aria-label": "Toggle channel list" },
    on: {
      click: function ($event) {
        return _vm.$store.commit("toggleSidebar")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }